var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Empty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 103 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.8824V30.7085C3 31.8131 3.89543 32.7085 5 32.7085H35C36.1046 32.7085 37 31.8131 37 30.7085V15.8824H30.0783C29.0793 15.8824 28.2696 16.6922 28.2696 17.6911C28.2696 19.7946 26.5644 21.4998 24.4609 21.4998H16.2C14.0965 21.4998 12.3913 19.7946 12.3913 17.6911C12.3913 16.6922 11.5815 15.8824 10.5826 15.8824H3ZM39 14.8824V30.7085C39 32.9176 37.2091 34.7085 35 34.7085H5C2.79086 34.7085 1 32.9176 1 30.7085V14.8824L9.07268 6.52143C9.82645 5.74073 10.8651 5.2998 11.9503 5.2998H27.9053C28.9783 5.2998 30.0062 5.73084 30.7583 6.49608L29.3318 7.89794C28.9558 7.51532 28.4418 7.2998 27.9053 7.2998H11.9503C11.4077 7.2998 10.8884 7.52027 10.5115 7.91062L4.74561 13.8824H10.5826C12.6861 13.8824 14.3913 15.5876 14.3913 17.6911C14.3913 18.69 15.2011 19.4998 16.2 19.4998H24.4609C25.4598 19.4998 26.2696 18.69 26.2696 17.6911C26.2696 15.5876 27.9748 13.8824 30.0783 13.8824H35.2131L29.3318 7.89794L30.7583 6.49608L39 14.8824Z",
    fill: "#E6EAEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.f976d5227ba7d971d7f7e28b166a9135.svg";
export { ForwardRef as ReactComponent };